export const faq = [
  {
    question: "How do I order a book?",
    answer:
      "Browse Products, add books to your basket, then place an order. Delivery is a flat $5.",
  },
  {
    question: "Can guests leave reviews?",
    answer:
      "Guests can browse Community reviews, but likes, replies, reviews and orders require login.",
  },
  {
    question: "How are Popular Books ranked?",
    answer: "Popular Books are sorted by unique authenticated views.",
  },
  {
    question: "I am blocked, what should I do?",
    answer: "Contact BooClub support from the Help Contact tab.",
  },
  {
    question: "How can I cancel an order?",
    answer: "Open Orders and cancel while the order is still in Paused status.",
  },
  {
    question: "Who developed this platform?",
    answer: "BooClub was reshaped from the Burak learning project into a bookstore platform.",
  },
];
